// extracted by mini-css-extract-plugin
export default {"wrapper":"customer-detail_wrapper__3Z7-M"};